"use client";
import { useEffect, useRef, useState } from "react";
import { headerData } from "../Header/Navigation/menuData";
import Logo from "./Logo";
import HeaderLink from "../Header/Navigation/HeaderLink";
import MobileHeaderLink from "../Header/Navigation/MobileHeaderLink";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";
import { bookAppointment } from "../../../../stateManagement/reducers/appointmentReducer";
import AnimateButton from "../../../../components/@extended/AnimateButton";

const Header: React.FC = () => {



  const [navbarOpen, setNavbarOpen] = useState(false);
  const [sticky, setSticky] = useState(false);
  const [isSignInOpen, setIsSignInOpen] = useState(false);
  const [isSignUpOpen, setIsSignUpOpen] = useState(false);

  const signInRef = useRef<HTMLDivElement>(null);
  const signUpRef = useRef<HTMLDivElement>(null);
  const mobileMenuRef = useRef<HTMLDivElement>(null);

  const handleScroll = () => {
    setSticky(window.scrollY >= 80);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      signInRef.current &&
      !signInRef.current.contains(event.target as Node)
    ) {
      setIsSignInOpen(false);
    }
    if (
      signUpRef.current &&
      !signUpRef.current.contains(event.target as Node)
    ) {
      setIsSignUpOpen(false);
    }
    if (
      mobileMenuRef.current &&
      !mobileMenuRef.current.contains(event.target as Node) &&
      navbarOpen
    ) {
      setNavbarOpen(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [navbarOpen, isSignInOpen, isSignUpOpen]);

  useEffect(() => {
    if (isSignInOpen || isSignUpOpen || navbarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [isSignInOpen, isSignUpOpen, navbarOpen]);

  return (
    <header
      className={`fixed top-0 z-40 w-full transition-all duration-300 bg-white ${sticky ? " shadow-lg mb:py-[.5rem] md:py-[1rem]" : "shadow-none py-6"
        }`}
    >
      <div className="lg:py-0 py-2">
        <div className="container w-[100%] max-w-[100%] mx-auto lg:max-w-screen-xl md:max-w-screen-md flex items-center justify-between px-4">
          <AnimateButton>
            <Logo />
          </AnimateButton>
          <nav className="hidden lg:flex flex-grow items-center gap-8 justify-center">
            {headerData.map((item, index) => (
              <HeaderLink key={index} item={item} />
            ))}
          </nav>
            <div className="flex items-center gap-4">
              <AnimateButton>
                <a
                  href="#"
                  className="block lg:block bg-primary text-white hover:bg-primary/15 hover:text-primary px-[1.25rem] py-[.75rem] lg:px-16 lg:py-5 rounded-full text-[1rem] lg:text-lg font-medium ml-auto"
                  onClick={e => {
                    e.preventDefault()
                    bookAppointment()
                  }}
                >
                  Contact Us
                </a>
              </AnimateButton>
              <button
                onClick={() => setNavbarOpen(!navbarOpen)}
                className="block lg:hidden p-2 rounded-lg"
                aria-label="Toggle mobile menu"
              >
                <span className="block w-6 h-0.5 bg-primary"></span>
                <span className="block w-6 h-0.5 bg-primary mt-1.5"></span>
                <span className="block w-6 h-0.5 bg-primary mt-1.5"></span>
              </button>
            </div>
        </div>
        {navbarOpen && (
          <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-40 " />
        )}
        <div
          ref={mobileMenuRef}
          className={`lg:hidden fixed top-0 right-0 h-full w-full bg-[white] shadow-lg transform transition-transform duration-300 max-w-xs ${navbarOpen ? "translate-x-0" : "translate-x-full"
            } z-50`}
        >
          <div className="flex items-center justify-between p-4">
            <h2 className="text-lg font-bold text-midnight_text dark:text-midnight_text">
              <Logo />
            </h2>

            {/*  */}
            <button
              onClick={() => setNavbarOpen(false)}
              className="bg-[url('assets/images/closed.svg')] bg-no-repeat bg-contain w-5 h-5 absolute top-0 right-0 mr-8 mt-8 dark:invert"
              aria-label="Close menu Modal"
            ></button>
          </div>
          <nav className="flex flex-col items-start p-4">
            {headerData.map((item, index) => (
              <MobileHeaderLink key={index} item={item} setIsNavOpen={setNavbarOpen} />
            ))}
            <div className="mt-4 flex flex-col space-y-4 w-full">
              <a
                href="#"
                className="bg-transparent border border-primary text-primary px-4 py-2 rounded-lg hover:bg-primary hover:text-[white]"
                onClick={e => {
                  e.preventDefault()
                  bookAppointment()
                }}
              >
                Contact Us
              </a>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
